<template>
  <div
    :class="[
      {
        [marginClasses]: !parentType || isAccordionContext,
        'max-w-prose': isAccordionContext,
      },
      globalClasses,
      { container: options.display !== 'fullwidth' && !parentType },
    ]"
  >
    <div v-if="!to && isVisible" class="paragraph-image">
      <MediaImage
        v-if="image"
        v-blokkli-droppable:field_media_reference
        v-bind="image"
        :style-name="styleName"
        :class="{
          'aspect-[3/2] object-cover': styleName === 'column_half_2_3',
        }"
      />
    </div>
    <DrupalLink v-else-if="to && isVisible" :to="to" class="paragraph-image">
      <MediaImage
        v-if="image"
        v-blokkli-droppable:field_media_reference
        v-bind="image"
        :style-name="styleName"
      />
    </DrupalLink>
  </div>
</template>

<script lang="ts" setup>
import type {
  FieldItemTypeLinkFragment,
  MediaImageFragment,
} from '#graphql-operations'
import type { LegacyImageStyle } from '~/helpers/imageStyles'

const { parentType, options } = defineBlokkli({
  bundle: 'image',
  globalOptions: ['region', 'marginTop'],
  options: {
    display: {
      type: 'radios',
      label: 'Display',
      default: 'fullwidth',
      options: {
        fullwidth: 'Fullwidth',
        contained: 'Contained',
      },
    },
  },

  editor: {
    determineVisibleOptions: function (ctx) {
      if ((ctx.parentType as string) === 'accordion') {
        return ['region', 'marginTop']
      }

      return ['region', 'display', 'marginTop']
    },
  },
})

const isAccordionContext = computed(
  () => (parentType.value as string | undefined) === 'accordion',
)

const { isVisible, globalClasses, marginClasses } =
  useMappedParagraphOptions(options)

const props = defineProps<{
  image?: MediaImageFragment
  link?: FieldItemTypeLinkFragment
}>()

/**
 * This can be provided by parent paragraphs to suggest an image style.
 */
const suggestedImageStyle = inject<ComputedRef<LegacyImageStyle> | null>(
  'imageStyle',
  null,
)

/**
 * The responsive image style name to use.
 */
const styleName = computed<LegacyImageStyle>(() => {
  if (!parentType.value) {
    return 'content_fullwidth'
  }
  return suggestedImageStyle?.value || 'column_half'
})

const to = computed(() => {
  return props.link?.uri?.path
})

defineOptions({
  name: 'ParagraphImage',
})
</script>
